import React from 'react';
import { Waves, Wrench, Sparkles, Settings } from 'lucide-react';
export function Services() {
  return <section id="services" className="py-24 bg-slate-50" data-id="element-185">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-186">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-187">
          <h2 className="text-blue-600 font-bold tracking-wide uppercase text-sm mb-3" data-id="element-188">
            Our Services
          </h2>
          <h3 className="text-3xl md:text-4xl font-extrabold text-slate-900 mb-4" data-id="element-189">
            Everything your pool needs to stay pristine.
          </h3>
          <p className="text-lg text-slate-600" data-id="element-190">
            From reliable weekly maintenance routes to complex equipment
            repairs, we handle it all so you can just swim.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8" data-id="element-191">
          {/* Primary Service - Weekly Route */}
          <div className="lg:col-span-3 bg-white rounded-3xl shadow-sm border border-slate-100 overflow-hidden group hover:shadow-md transition-shadow" data-id="element-192">
            <div className="grid grid-cols-1 md:grid-cols-2" data-id="element-193">
              <div className="p-8 md:p-12 flex flex-col justify-center" data-id="element-194">
                <div className="w-14 h-14 bg-blue-100 rounded-2xl flex items-center justify-center mb-6" data-id="element-195">
                  <Waves className="w-7 h-7 text-blue-600" data-id="element-196" />
                </div>
                <h4 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-197">
                  Weekly Pool Service Route
                </h4>
                <p className="text-slate-600 mb-6 leading-relaxed" data-id="element-198">
                  Our core offering. Get on our route and never worry about
                  water chemistry, skimming, or emptying baskets again. We
                  provide consistent, flat-rate weekly service to keep your
                  oasis swim-ready 365 days a year.
                </p>
                <ul className="space-y-3 mb-8" data-id="element-199">
                  {['Water testing & chemical balancing', 'Skimming & vacuuming', 'Emptying skimmer & pump baskets', 'Brushing walls & steps', 'Filter cleaning & backwashing'].map((item, i) => <li key={i} className="flex items-center gap-3 text-slate-700 font-medium" data-id="element-200">
                      <div className="w-1.5 h-1.5 rounded-full bg-blue-500" data-id="element-201" />
                      {item}
                    </li>)}
                </ul>
                <div data-id="element-202">
                  <button onClick={() => document.getElementById('contact')?.scrollIntoView({
                  behavior: 'smooth'
                })} className="text-blue-600 font-bold hover:text-blue-700 flex items-center gap-2 group/btn" data-id="element-203">
                    Get a Quote for Weekly Service
                    <span className="group-hover/btn:translate-x-1 transition-transform" data-id="element-204">
                      →
                    </span>
                  </button>
                </div>
              </div>
              <div className="h-64 md:h-auto relative" data-id="element-205">
                <img src="https://images.unsplash.com/photo-1582268611958-ebfd161ef9cf?auto=format&fit=crop&q=80&w=1000" alt="Clean pool water" className="absolute inset-0 w-full h-full object-cover" data-id="element-206" />
              </div>
            </div>
          </div>

          {/* Secondary Services */}
          <div className="bg-white p-8 rounded-3xl shadow-sm border border-slate-100 hover:shadow-md transition-shadow" data-id="element-207">
            <div className="w-12 h-12 bg-slate-100 rounded-xl flex items-center justify-center mb-6" data-id="element-208">
              <Wrench className="w-6 h-6 text-slate-700" data-id="element-209" />
            </div>
            <h4 className="text-xl font-bold text-slate-900 mb-3" data-id="element-210">
              Expert Repairs
            </h4>
            <p className="text-slate-600 mb-4" data-id="element-211">
              Pumps making noise? Heater not firing? We handle complex plumbing,
              leak detection, and resurfacing. Our senior experts tackle the
              tough jobs.
            </p>
          </div>

          <div className="bg-white p-8 rounded-3xl shadow-sm border border-slate-100 hover:shadow-md transition-shadow" data-id="element-212">
            <div className="w-12 h-12 bg-cyan-50 rounded-xl flex items-center justify-center mb-6" data-id="element-213">
              <Sparkles className="w-6 h-6 text-cyan-600" data-id="element-214" />
            </div>
            <h4 className="text-xl font-bold text-slate-900 mb-3" data-id="element-215">
              Tile & Calcium Cleaning
            </h4>
            <p className="text-slate-600 mb-4" data-id="element-216">
              <span className="italic font-medium text-slate-800" data-id="element-217">
                "Calcium is good for your bones, but not for your pool tile."
              </span>{' '}
              We safely blast away stubborn scale to restore your tile's
              original shine.
            </p>
          </div>

          <div className="bg-white p-8 rounded-3xl shadow-sm border border-slate-100 hover:shadow-md transition-shadow" data-id="element-218">
            <div className="w-12 h-12 bg-indigo-50 rounded-xl flex items-center justify-center mb-6" data-id="element-219">
              <Settings className="w-6 h-6 text-indigo-600" data-id="element-220" />
            </div>
            <h4 className="text-xl font-bold text-slate-900 mb-3" data-id="element-221">
              Equipment Upgrades
            </h4>
            <p className="text-slate-600 mb-4" data-id="element-222">
              Upgrade to energy-efficient variable speed pumps, smart automation
              systems, and modern filtration to save money and improve water
              quality.
            </p>
          </div>
        </div>
      </div>
    </section>;
}